import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { closeNode } from 'modules/workflows/ducks';
import { PrimaryButton, SecondaryButton } from 'ui/button';
import { Add24 } from 'ui/icons';
import { EmptyStateEmbedded } from 'ui/illustrations';
import { Body2, H4, colors, spacing } from 'ui/theme';

const EmptyPlacementWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9;
  padding: ${spacing.x3};
  text-align: center;
`;

const Section = styled.div`
  padding-bottom: ${spacing.plusHalf};
`;

const StyledBody2 = styled(Body2)`
  color: ${colors.textSecondary};
`;

const ButtonSection = styled(Section)`
  display: flex;
  gap: ${spacing.half};
  justify-content: center;
`;

export const ADD_PLACEMENT_SECTION_TEST_ID = 'add-placement-section';
export const ADD_PLACEMENT_BUTTON_TEST_ID = 'add-placement-button';

export const EmptyPlacementSection = () => {
  const dispatch = useDispatch();

  const onCreatePlacementClick = () => {
    const url = `${window.location.origin}/settings/placements`;
    window.open(url, '_blank')?.focus();
    dispatch(closeNode());
  };

  return (
    <EmptyPlacementWrapper data-test={ADD_PLACEMENT_SECTION_TEST_ID}>
      <Section>
        <EmptyStateEmbedded />
      </Section>
      <Section>
        <H4>Ready to start displaying embedded messages?</H4>
        <StyledBody2>
          Before you can create a embedded campaign, you’ll need to create a placement it can
          target. Learn more in our documentation or get started right away!
        </StyledBody2>
      </Section>
      <ButtonSection>
        <SecondaryButton
          // @ts-ignore
          as="a"
          target="_blank"
          rel="noopener noreferrer"
          href="https://support.iterable.com/hc/articles/23061496928788"
        >
          Learn more
        </SecondaryButton>
        <PrimaryButton onClick={onCreatePlacementClick} data-test={ADD_PLACEMENT_BUTTON_TEST_ID}>
          <Add24 />
          Create placement
        </PrimaryButton>
      </ButtonSection>
    </EmptyPlacementWrapper>
  );
};
